var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4194 13.7297L2.51991 3.83019L3.58057 2.76953L13.4801 12.669L12.4194 13.7297Z",
    fill: "#ACB1BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4802 3.83109L3.58068 13.7306L2.52002 12.6699L12.4195 2.77043L13.4802 3.83109Z",
    fill: "#ACB1BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeCloseIcon);
export default __webpack_public_path__ + "static/media/welcome-close-icon.9a787404997184aecc597d02242c4187.svg";
export { ForwardRef as ReactComponent };